<!--
 @author wangjp
 @description 客服 表单
 @date 2024年9月12日16:51:06
 -->
<template>
  <el-container>
    <el-dialog title="编辑" :visible="formVisible" :before-close="handleClose" append-to-body :wrapperClosable="false"
               @open="handleOpen" :close-on-click-modal="false">
      <div style="height: calc(100% - 90px);">
        <el-row style="padding: 30px">
          <el-form ref="form" :model="form" :rules="rules" label-width="130px">
            <el-form-item label="客服名称" prop="counselorName">
              <el-input v-model="form.counselorName" placeholder="请输入客服名称" size="medium"/>
            </el-form-item>
            <el-form-item label="所属科室" prop="hospitalDept">
              <el-input v-model="form.hospitalDept" placeholder="请输入所属科室" size="medium"/>
            </el-form-item>
            <el-form-item label="手机号码" prop="phoneNo">
              <el-input v-model="form.phoneNo" placeholder="请输入手机号码" size="medium"/>
            </el-form-item>
            <el-form-item label="电子邮箱" prop="emailNo">
              <el-input v-model="form.emailNo" placeholder="请输入电子邮箱" size="medium"/>
            </el-form-item>
            <el-form-item label="地址" prop="addr">
              <el-input v-model="form.addr" placeholder="请输入地址" size="medium"/>
            </el-form-item>
            <el-form-item label="微信号" prop="wxNo">
              <el-input v-model="form.wxNo" placeholder="请输入微信号" size="medium"/>
            </el-form-item>
            <el-form-item label="客服介绍" prop="introduce">
              <el-input type="textarea" v-model="form.introduce" placeholder='请输客服介绍' size="medium" />
            </el-form-item>
            <el-form-item label="客服照片" prop="attachList">
              <el-upload action="/sysAttach/uploadTempAttach/COUNSELOR_PHOTO"
                         list-type="text" :accept="attachAcceptType"
                         :on-error="attachHandleError" :on-success="attachHandleSuccess"
                         :on-remove="attachHandleRemove" :on-preview="attachHandlePreview"
                         :before-upload="attachBeforeUpload" :before-remove="attachBeforeRemove"
                         :on-exceed="attachHandleExceedOne" :file-list="attachList" :limit="1"
                         :show-file-list=true multiple style="width: 400px">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip" style="color: red"> 上传文件大小不超过10MB，最多上传1个附件</div>
              </el-upload>
            </el-form-item>
          </el-form>
        </el-row>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit" :disabled="$store.state.loading" size="medium">确 定</el-button>
        <el-button @click="handleClose" :disabled="$store.state.loading" size="medium">取 消</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import {commonFormMixin} from '@/utils/commonFormMixin'
import {commonAttachMixin} from "@/utils/commonAttachMixin";
export default {
  name: "CounselorBaseForm",
  mixins: [commonFormMixin,commonAttachMixin],
  props: ['formVisible', 'selRow', 'submitUrl'],
  data() {
    return {
      attachList:[],
      attachAcceptType: '.jpg,.jpeg,.png,.PNG,.JPG,.JPEG',
      rules: {
        counselorName: [
          {required: true, message: '客服名称不能为空', trigger: 'blur'}
        ],
        hospitalDept: [
          {required: true, message: '所属科室不能为空', trigger: 'blur'}
        ],
        phoneNo: [
          {required: true, message: '手机号码不能为空', trigger: 'blur'}
        ],
        emailNo: [
          {required: true, message: '电子邮箱不能为空', trigger: 'blur'}
        ],
      }
    }
  },
  methods: {
    attachHandleExceedOne(files, fileList) {
      this.$message.warning(`只能上传1个附件`)
    },
    async handleOpen() {
      this.form = {...this.selRow}
      this.attachList = [];
      if (this.form.id) {
        this.attachList = await this.findAttachListByDataId(this.form.id, 'COUNSELOR_PHOTO')
      }
    },
  }
}
</script>